import React, { FC } from 'react';
import { OpeningHeader } from '@src/containers/Source/Header/OpeningHeader';
import { useGetOpeningId } from '../hooks/useGetOpeningId';
import { ApplicantCounts } from './ApplicantCounts';
import { HeaderProps } from './props';
import './styles.scss';

export const Header: FC<HeaderProps> = ({
  recommended,
  totalUnanswered,
  openingState,
  totalMessaged,
  isLoading,
  unreadMessagesCount,
  totalShortlist,
  unreadShortlistApplicants,
}) => {
  const openingId = useGetOpeningId();

  return (
    <div className="opening-page-header">
      <div className="opening-page-header__top">
        {openingId && (
          <OpeningHeader activeOpeningId={openingId} isActiveOpeningLoading={isLoading} isApplicantsLinkHidden />
        )}
      </div>

      {openingId && (
        <ApplicantCounts
          inConversation={totalMessaged}
          openingState={openingState}
          openingId={openingId}
          pending={totalUnanswered}
          recommended={recommended}
          totalShortlist={totalShortlist}
          unreadMessagesCount={unreadMessagesCount}
          unreadShortlistApplicants={unreadShortlistApplicants}
        />
      )}
    </div>
  );
};
